import { Http, Request, Response } from '../domain/models/index';
import { URLParserBase, createURLParser } from '../util/index';

export class HttpXhr implements Http {
    constructor(private base?: URLParserBase) {}

    request<V>(request: Request<{}>): Promise<Response<V>>;

    request<T, V>(request: Request<T>): Promise<Response<V>> {
        return new Promise<Response<V>>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const parser = createURLParser(request.url, this.base);
            parser.search = request.search || parser.search;
            xhr.open(request.method || 'GET', parser.href);
            if (typeof request.withCredentials === 'boolean') {
                xhr.withCredentials = request.withCredentials;
            }

            const headers = request.headers || {};
            Object.keys(headers).forEach((header) => {
                xhr.setRequestHeader(header, headers[header]);
            });

            xhr.addEventListener('load', () => {
                let body: any;
                try {
                    body = JSON.parse(xhr.response);
                } catch (err) {
                    body = xhr.response;
                }

                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve({
                        body,
                        status: xhr.status
                    });
                } else {
                    reject({
                        body,
                        status: xhr.status
                    });
                }
            });

            xhr.addEventListener('error', (err: ErrorEvent) => {
                reject({
                    status: xhr.status,
                    body: err.message
                });
            });

            xhr.send(JSON.stringify(request.body));
        });
    }
}
